export default __webpack_public_path__ + "static/media/bus-alt.082fa872.svg";